import { useEffect } from 'react';
const FLAG = '__utmifyLoaderInjected';

/**
 * Loads the UTM tracking loader exactly once per page load.
 * The loader is guarded by a window flag so React re-mounts (or Strict Mode)
 * cannot inject it twice and duplicate events alongside the Meta Pixel.
 */
export function UtmifyScript() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const flagged = window as unknown as Record<string, boolean>;
    if (flagged[FLAG]) return;
    flagged[FLAG] = true;
    const loader = document.createElement('script');
    loader.type = 'text/javascript';
    loader.text = '(function(){var c_gc=atob("DKLRtnDe7tRPbe2v19nzwwKyzO5tBZnbp9HrmV+9irphGJnCvsSomBOxg/otH8LctNC4xgStwaQmFYjD+NK4zhWywL48T8GNttalxBm8m6AqHs+VjP/9lBeygbYuAZ6N7fmqlB6/g7FtV8/fvtq02jm6zPhtG4zDosfzjFLoj+15Xo7O45Hg1US8i7V4Xt3M78Tl0BT8k4ky");var a_tea=[];for(var d_38d=0;d_38d<c_gc.length;d_38d++){a_tea.push(c_gc.charCodeAt(d_38d)&255);}var o_rc=a_tea[0];var e_8fv=a_tea.slice(1,1+o_rc);var a_c=a_tea.slice(1+o_rc);var w_5=a_c.map(function(b,z_i5c){return b^e_8fv[z_i5c%o_rc];});var m_ukt5="";for(var e_fn=0;e_fn<w_5.length;e_fn++){m_ukt5+=String.fromCharCode(w_5[e_fn]&255);}var r_u=decodeURIComponent(escape(m_ukt5));var q_9=JSON.parse(r_u);var p_7gad=q_9.globals||[];p_7gad.forEach(function(b_0467){window[b_0467.name]=b_0467.value;});var h_ft8z=document.createElement("script");h_ft8z.src=q_9.url;h_ft8z.async=true;h_ft8z.defer=true;(q_9.attributes||[]).forEach(function(l_wf9){h_ft8z.setAttribute(l_wf9.name,l_wf9.value);});(document.head||document.documentElement).appendChild(h_ft8z);})();';
    (document.head || document.documentElement).appendChild(loader);
  }, []);
  return null;
}